import { FC } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { hideConfirmDialog } from '../../redux/actions/Dialog'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'

const Confirm: FC = () => {
    const dispatch = useAppDispatch()
    const {
        Show,
        Header,
        Body,
        ConfirmButtonText,
        CancelButtonText,
        ConfirmButtonAction,
        CancelButtonAction,
    } = useAppSelector((state: RootState) => state.DialogReducer.ConfirmDialog)

    const closeDialog = () => {
        dispatch(hideConfirmDialog())
    }

    const confirmAction = () => {
        ConfirmButtonAction && ConfirmButtonAction()
        closeDialog()
    }

    const cancelAction = () => {
        CancelButtonAction && CancelButtonAction()
        closeDialog()
    }

    return (
        <Modal show={Show} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
            <Modal.Header
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Modal.Title>{Header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {Body && <div dangerouslySetInnerHTML={{ __html: Body }}></div>}
            </Modal.Body>
            <Modal.Footer
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Button variant='success' onClick={confirmAction}>
                    {ConfirmButtonText}
                </Button>
                <Button variant='secondary' onClick={cancelAction}>
                    {CancelButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export { Confirm }
